import Homepage from "../homepage/homepage";

const ParentLoginLayout = () => {
  return <Homepage />;
};

export default ParentLoginLayout;
